import React from 'react';
import { connect } from 'react-redux';
import { Button, Col, message, Modal, Popconfirm, Popover, Row, Steps, Tag, Input } from 'antd';
import axios from 'axios';
import { API_ENDPOINT } from '../../../index';

import HoldingList from "./holdinglist"
import HoldingListSelector from './holding-list-selector';
import QuotationPricing from "./pricing"
import UserSelector from './user-selector';

import { 
  _getMyHoldingList,
  _postApproveManualPayment,
  _postCancelQuote,
  _postDuplicateCartToHoldingList,
  _postSendQuotation,
  _postSetQuotationHoldingList,
  _postNewHoldingList,
  _postAddProductToHoldingList,
  _postAddPurchaseOrderRefNumber,
  _postWaiveGst
} from '../../../services';

import { 
  setQuotationCancelled,
  setQuotationLastContact,
  setQuotationPaymentObject,
  setQuotationProducts 
} from '../actions';

import "./modal.css"

const Step = Steps.Step;

class AddQuotationModal extends React.Component {
  render() {
    const { cart } = this.props.quotation;
    
    if( !cart.refNumber ){
      return null;
    }
    
    const steps = [
      {
        title: "Select User",
        content: "User Selector Component",
        render: (
          <div style={{ padding: 32, paddingTop: 0 }}>
            <UserSelector />
          </div>
        )
      },
      
      {
        title: "Holding Lists",
        content: 'Holding List Component',
        render: (
          <div style={{ padding: 32, paddingTop: 0 }}>
            {this.renderUserPopup()}
            <div key="holding-list">

              <HoldingListSelector 
                selectedListId={this.state.selectedListId}
                
                handleOnSelectHoldingList={this.handleOnSelectHoldingList}
                setHoldingListBulkDiscount={this.setHoldingListBulkDiscount}
                setHoldingListProduct={ this.setHoldingListProduct }
                
                deleteHoldingListProduct={ this.deleteHoldingListProduct }
                updateHoldingListProductQuantity={ this.updateHoldingListProductQuantity }

                updateHoldingListProductSerialNumber={ this.updateHoldingListProductSerialNumber }

                updateSelectedList={this.updateSelectedList}
                updateHoldingLists={this.updateHoldingLists}

                handleOnDeleteHoldingList={ this.handleOnDeleteHoldingList }
                />
              {/* <HoldingList
                holdingList={this.state.holdingLists}
                selectedListId={this.state.selectedListId}
                
                setSelectedHoldingListid={this.setSelectedHoldingListid}
                setHoldingListBulkDiscount={this.setHoldingListBulkDiscount}
                setHoldingListProduct={ this.setHoldingListProduct }
                
                deleteHoldingListProduct={ this.deleteHoldingListProduct }
                updateHoldingListProductQuantity={ this.updateHoldingListProductQuantity }

                updateHoldingListProductSerialNumber={ this.updateHoldingListProductSerialNumber }

                updateSelectedList={this.updateSelectedList}
                updateHoldingLists={this.updateHoldingLists}
                />  */}
            </div>
          </div>    
        )
      }, 
      
      {
        title: "Pricing",
        content: 'Pricing Component',
        render: (
          <QuotationPricing 
            noEdit={this.state.noEdit}
          />
        )
    }];

    return (
      <div>

       <Modal
          maskClosable={false}
          title={ this.renderModalTitle( cart ) }
          // wrapClassName="vertical-center-modal"
          closable={false}
          top={ 20 }
          visible={this.props.modalIsVisible}
          onCancel={this.props.hideModal}
          width={900}
          bodyStyle={{ padding: 0 }}
          footer={
            <Row gutter={8} type="flex" justify="end">
              <Col>
                <Button onClick={this.props.hideModal}>Cancel</Button>
              </Col>

              <Col>
              {
                  this.state.current > 0
                  &&
                  <Button 
                    disabled={this.state.noEdit}
                    type='primary' 
                    onClick={() => this.prev()}>Previous</Button>
              }
              </Col>

              {
                this.state.current < steps.length - 1 && (
                  <Col>
                    <Button 
                      disabled={this.state.noEdit}
                      type='primary'  onClick={() => this.next()}>Next</Button>
                  </Col>
                )
              }


              {
                this.state.current === steps.length - 1 && 
                !this.props.quotation.cart.punchoutCart && (
                  <Col>
                    <Button
                      disabled={this.state.noEdit}
                      type="primary" onClick={this.sendQuotation}>Send Quotation</Button>
                  </Col>
                )
              }


              {
                this.state.current === steps.length - 1
                &&
                (
                  <Col>
                  
                  {this.state.noEdit && (
                    <Button
                      disabled={true}
                      type="primary">Send Invoice</Button>
                  )}
                  
                  { !this.state.noEdit && (
                    <Popconfirm
                      title={"Are you sure? Your email will be logged."} 
                      onConfirm={ this.sendInvoice } 
                      okText="Yes" 
                      cancelText="No">
  
                        <Button
                          disabled={this.state.noEdit}
                          type="primary">Send Invoice</Button>
                    
                    </Popconfirm>
                  )}
                  
                  </Col>
                )
              }
            </Row>
          }
        >
        
          {
            !this.state.noEdit && (
              <div style={{ padding: 32 }}>
                <Steps current={this.state.current}>
                  {steps.map(item => <Step key={item.title} title={item.title} />)}
                </Steps>
              </div>
            )
          }
          
          <div className="steps-content">{ steps[this.state.current].render }</div>
    
        </Modal>
   
      </div>
    )
  }

  renderModalTitle = ( cart ) => {


    return (
      <Row type="flex" justify="space-between" align="middle">
        <Col>
          <Row type="flex">
            <Col>
              Ref Number: {cart.refNumber}
            </Col>
          </Row>
        </Col>
        <Col>
          <Row>
              <Col>
                <Row type="flex" gutter={8}>
                
                    {
                      cart.lastContact && (cart.lastContact.quoteAndForgetDate || cart.lastContact.invoiceDate) &&
                      (
                        <Col>
                          <Button 
                            onClick={this.toggleCreateDuplicateQuotation}>
                            Create Duplicate
                          </Button>
                        </Col>)
                    }
                        
                  {
                    cart.payment && cart.payment.approverUserId && (
                      <Col>
                        <Tag color="gold">Payment Approver: {this.props.admins.userIdEmailMap[cart.payment.approverUserId]}</Tag>
                      </Col>
                    )
                  }

                  {
                    cart.cancelled && cart.cancelledBy && (
                      <Col>
                        <Tag color="red">Cancelled By: {cart.cancelledBy}</Tag>
                      </Col>
                    )
                  }

                  {
                    !cart.cancelled && cart.lastContact && cart.lastContact.quoteAndForgetDate && !cart.lastContact.invoiceDate && [
                      (
                        <Col>
                          <Popconfirm
                            title={"Are you sure? Canceling quote will stop all email reminders and prevents us from proceeding with order should user choose to accept in the future."} 
                            onConfirm={ this.cancelQuote } 
                            okText="Yes" 
                            cancelText="No">

                            <Button 

                              type="danger">
                              Cancel Quote
                            </Button>

                          </Popconfirm>
                        </Col>
                      ),

                      (
                        <Col>
                          <Button 
                            onClick={ this.sendQuotation }>
                            Send Again
                          </Button>
                        </Col>
                      ),

                      // {/* <Col>
                      //   <Input
                      //     placeholder="PO"
                      //     onPressEnter={this.handleOnPressEnter}/> 
                      // </Col> */}

                      (
                        <Col>
                          <Popconfirm
                            title={"Are you sure? Your email will be logged."} 
                            onConfirm={ this.approveManualPayment } 
                            okText="Yes" 
                            cancelText="No">

                            <Button 

                              type="primary">
                              Confirm Paid
                            </Button>

                          </Popconfirm>

                        </Col>
                      )
                    ]
                  }
              </Row>

            </Col>
          </Row>
        </Col>
        
      </Row>
    )
  }
  
  renderUserPopup = () => {
    
    const activeShipping = this.props.quotation.cart.activeShipping || {};
    
    
    
    return (
      
      <Row key="user-details-popup" type="flex" justify="center">
        <Col>
          <Popover
            placement="right"
            className="h1-font"
            content={(
              <div>
                
                  <span>{activeShipping.companyName}</span><br />
                  <span>{activeShipping.name}</span><br />
                  <span>{activeShipping.hp}</span><br />
                  <span>{activeShipping.country}</span><br />
                  <span>{activeShipping.unit}</span><br />
                  <span>{activeShipping.postalCode}</span><br />
                  <span>{activeShipping.address}</span><br />
                
              </div>
            )}
          >
            <Button type="primary">Company Details</Button>
          </Popover>
        </Col>
      </Row>

    )
  }

  constructor(props) {

    super(props);
    
    let current = 0;
    let noEdit = false;

    if( 
      props.quotation.cart && 
      props.quotation.cart.instantInvoice && 
      props.quotation.cart.lastContact.invoiceDate
    ){
      current = 2;
      noEdit = true;
    }

    if( 
        props.quotation.cart && 
        props.quotation.cart.lastContact && 
        props.quotation.cart.lastContact.quoteAndForgetDate
    ){
      current = 2;
      noEdit = true;
    }

    this.state = {
      current,
      noEdit,
      duplicatedQuotation:false,
      user: {
        company: "",
        name: "",
        number: "",
        email: "",
        country: [],
        postalCode: "",
        unitNumber: "",
        address: "",
      },
      
      userDatabase: [],

      selectedListKey: -1,

      holdingList: [],

      selectedList: {},

      selectedListId:props.quotation.cart.holdingListId,
      cartId: "",
    }

    // if( props.quotation.cart._id && props.quotation.cart.holdingListId ){

    //   this.setState({
    //     selectedListId: props.quotation.cart.holdingListId
    //   });

    // }


    this.updateCDState = this.updateCDState.bind(this);
    this.updatePState = this.updatePState.bind(this);
    this.updateCart = this.updateCart.bind(this);
  }

  componentDidMount() {

    // _getMyHoldingList()
    //   .then(res => {
    //     // console.log(res.data.holdingList)
    //     this.setState({ holdingList: res.data.holdingList.reverse() })
        
    //   })
    //   .catch(err => {
    //     // alert(JSON.stringify(err.response)  )
    //   })
      
  }

  approveManualPayment = ({ instantInvoice = false }) => {
    
    const { quotation } = this.props;
    
    message.loading('Approving Payment Manually..',0);

    return _postApproveManualPayment({ 
      cartId: quotation.cart._id, 
      instantInvoice 
    })
      .then( res => {

        message.destroy();
				message.success("Manual Payment approved!");

        this.props.setQuotationLastContact( res.data.lastContact );
        this.props.setQuotationPaymentObject( res.data.payment );

				// this.props.updateOrderPaymentObject( res.data.payment );

      })
  }

  cancelQuote = () => {
    const { quotation } = this.props;
    
    message.loading('Cancelling quote..',0);

    _postCancelQuote( quotation.cart._id )
      .then( res => {

        message.destroy();
				message.success("Quote Cancelled! No more reminders will be sent.");

        this.props.setQuotationCancelled( res.data.cancelledBy );

				// this.props.updateOrderPaymentObject( res.data.payment );

      })
  }

  deleteHoldingListProduct = ({ holdingListId, productIndex }) => {
    this.setState({
      holdingList: this.state.holdingLists.map(
        hl => {
          
          if( hl._id !== holdingListId ){
            return hl;
          }
          
          hl.products.splice(productIndex, 1);

          return {
            ...hl
          }
          
        }
      )
    })
  }

  updateCDState = (value) => {
    this.setState({
      user: value
    })
  }

  handleOnSelectHoldingList = ( holdingList ) => {

    this.setState({
      selectedListId: holdingList._id,
    });

  }

  setHoldingListBulkDiscount = ({ discount, productIndex, holdingListId }) => {
    
    this.setState({
      holdingList: this.state.holdingLists.map(
        hl => {
          
          if( hl._id !== holdingListId ){
            return hl;
          }
          
          return {
            ...hl,
            products: hl.products.map( (hlProduct, hlProductIndex) => {
              if( hlProductIndex !== productIndex ){
                return hlProduct
              }
              
              return {
                ...hlProduct,
                discount
              }
            })
          }
          
        }
      )
    })

  }

  setHoldingListProduct = ({ productIndex, product, holdingListId }) => {
    this.setState({
      holdingList: this.state.holdingLists.map(
        hl => {
          
          if( hl._id !== holdingListId ){
            return hl;
          }
          
          return {
            ...hl,
            products: hl.products.map( (hlProduct, hlProductIndex) => {
              if( hlProductIndex !== productIndex ){
                return hlProduct
              }
              
              return product;
            })
          }
          
        }
      )
    })
  }
  
  
  updateHoldingListProductQuantity = ({ quantity, holdingListId, productIndex }) => {
    
    this.setState({
      holdingList: this.state.holdingLists.map(
        hl => {
          
          if( hl._id !== holdingListId ){
            return hl;
          }
          
          return {
            ...hl,
            products: hl.products.map( (hlProduct, hlProductIndex) => {
              if( hlProductIndex !== productIndex ){
                return hlProduct
              }

              return {
                ...hlProduct,
                quantity,
                quoteAndForgetCustomBulkDiscount: quantity > 1? hlProduct.quoteAndForgetCustomBulkDiscount: 0
              }
            })
          }
          
        }
      )
    })

  }

  updateHoldingListProductSerialNumber = ({ serialNumber, holdingListId, productIndex }) => {
    this.setState({
      holdingList: this.state.holdingLists.map(
        hl => {
          
          if( hl._id !== holdingListId ){
            return hl;
          }
          
          return {
            ...hl,
            products: hl.products.map( (hlProduct, hlProductIndex) => {
              if( hlProductIndex !== productIndex ){
                return hlProduct
              }

              return {
                ...hlProduct,
                serialNumber
              }
            })
          }
          
        }
      )
    })
  }

  updateHoldingLists = ( value ) => {
    
    this.setState({
      holdingList: value
    })
    
  }

  updateCart = (cartId) => {
    this.setState({ cartId })
  }

  updateSelectedList = ( selectedList ) => {

    

    this.setState({ selectedList })
  }

  updatePState = (value) => {
    // this.setState({
    //   selectedList: value
    // })
  }

  toggleCreateDuplicateQuotation = () =>{
    
    this.setState({duplicatedQuotation:true});

    _postDuplicateCartToHoldingList({ cartId: this.props.quotation.cart._id  })
      .then( res => {
        
        message.success("Duplicate holding list created");
        this.setState({duplicatedQuotation:false});

      })

  }

  handleOnPressEnter = (e) =>{
    console.log(e.target.value);
    
    let poRefNumber = e.target.value;
    let cartId = this.props.quotation.cart._id;

    _postAddPurchaseOrderRefNumber({cartId, poRefNumber})
    .then( res => {
      console.log(res);
      message.success("Added PO");
      //refresh PDF?
    })


  }

  next = () => {

    let { current } = this.state;

    switch( current ){
      case 0:

        if( 
          !this.props.quotation.cart.activeShipping ||
          !this.props.quotation.cart.activeBilling ||
          !this.props.quotation.cart.activeShipping._id || 
          !this.props.quotation.cart.activeBilling._id
        ){
          return message.error("Please select a billing and shipping address.");
        }

        current = 1;

        if( this.props.quotation.cart.punchoutCart ){
          current = 2;
        }

        this.setState({
          current
        });

        break;

      case 1:

        // if holding list step and did not select a holding list
        if(!this.state.selectedListId){
          message.destroy();
          return message.error('Please select a holding list!');
        }

        // send request to add hl._id and hl.products to cart
        let assignMsg = message.loading('Assigning holding list to quotation');

        _postSetQuotationHoldingList({
          holdingListId: this.state.selectedListId,
          quotationId: this.props.quotation.cart._id
        })
          .then( res => {
            setTimeout(() => {
              assignMsg();
              message.success('Holding List assigned');

              this.setState({ 
                current: 2
              });

              this.props.setQuotationProducts( res.data.products );

            }, 1000)

          })
          .catch( e => {
            message.error("There was an expected error.");
          });

        break;

    }

    // if holding list step and selected a holding list
    // if( current === 1 && this.state.selectedListId){
    //   // send request to add hl._id and hl.products to cart
    //   _postSetQuotationHoldingList({
    //     holdingListId: this.state.selectedListId,
    //     quotationId: this.props.quotation.cart._id
    //   })
    //     .then( res => {

    //     })
    //     .catch( e => {

    //     });

    // } else if( current === 1 && !this.state.selectedListId ) {
    //   // if holding list step and did not select a holding list
    //   message.destroy();
    //   return message.error('Please select a holding list!');
    // }

    // this.setState({ 
    //   current: current + 1
    // });

  }

  prev() {
    let current = this.state.current - 1;
    
    if( this.props.quotation.cart.punchoutCart ){
      current = 0;
    } 

    this.setState({ current });
  }


  sendInvoice = () =>{
    
    
    message.loading( "Sending Invoice..", 0 );
    
    this.approveManualPayment({ instantInvoice: true })
      .then( () => {
        
        this.props.hideModal();
        
      });
    


  }

  sendQuotation = () => {

    let sending = message.loading('Sending Quotation...');

    _postSendQuotation( this.props.quotation.cart._id )
      .then( res => {
        setTimeout(() => {
          sending();

          message.success(`Quotation Sent to ${this.props.quotation.cart.user.local.email}!`);
          this.props.hideModal();
        }, 500);
      })

        // this.setState({
        //   current: 0,

        //   user: {
        //     company: "",
        //     name: "",
        //     number: "",
        //     email: "",
        //     country: [],
        //     postalCode: "",
        //     unitNumber: "",
        //     address: "",
        //   },
          
        //   selectedListKey: -1,

        //   holdingList: [],

        //   selectedList: {},
        // })
  }

  handleOk = (e) => {
    console.log(e);
    this.setState({
      
    });
 
    const current = 0;
    this.setState({ current });
  }

  handleCancel = (e) => {
    console.log(e);
    this.setState({
    });
  }
}

export default connect(
  state => ({
    quotation: state.quotation,
    admins: state.admins
  }),

  dispatchEvent => ({
    setQuotationCancelled: ( cancelledByEmail ) => dispatchEvent( setQuotationCancelled( cancelledByEmail )  ),
    setQuotationPaymentObject: ( payment ) => dispatchEvent( setQuotationPaymentObject( payment ) ),
    setQuotationLastContact: ( lastContact ) => dispatchEvent( setQuotationLastContact( lastContact ) ),
    setQuotationProducts: ( products ) => dispatchEvent( setQuotationProducts( products ) )
  })
)(AddQuotationModal);


// WEBPACK FOOTER //
// ./src/components/quotation/add-quotation-modal/index.js